import React from 'react';
import { AlertCircle, CheckCircle2, Inbox, LoaderCircle } from 'lucide-react';

export function ErrorMessage({ children }) {
  if (!children) return null;
  return (
    <div
      role="alert"
      className="mb-4 flex items-start gap-2.5 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800"
    >
      <AlertCircle size={18} className="mt-0.5 shrink-0 text-red-600" />
      <span>{children}</span>
    </div>
  );
}

export function SuccessMessage({ children }) {
  if (!children) return null;
  return (
    <div
      role="status"
      className="mb-4 flex items-start gap-2.5 rounded-lg border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800"
    >
      <CheckCircle2 size={18} className="mt-0.5 shrink-0 text-emerald-600" />
      <span>{children}</span>
    </div>
  );
}

export function Loading({ label = 'Loading...' }) {
  return (
    <div
      role="status"
      className="flex items-center justify-center gap-2 py-12 text-sm text-ink-muted"
    >
      <LoaderCircle className="animate-spin text-brand-600" size={18} />
      {label}
    </div>
  );
}

export function EmptyState({
  title = 'No records found',
  detail = 'Items will appear here when available.',
}) {
  return (
    <div className="px-6 py-14 text-center">
      <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-50 text-brand-600">
        <Inbox size={22} />
      </div>
      <p className="font-semibold text-ink">{title}</p>
      <p className="mt-1 text-sm text-ink-muted">{detail}</p>
    </div>
  );
}
